﻿import Cookies from 'js-cookie';

export interface IBrowserStorage {
   set(key: string, data: string): void;
   remove(key: string): void;
   get(key: string): string | null | undefined;
}

export class LocalStorage implements IBrowserStorage {
   set(key: string, data: string): void {
      window.localStorage.setItem(key, data);
   }
   remove(key: string): void {
      window.localStorage.removeItem(key);
   }
   get(key: string): string | null | undefined {
      return window.localStorage.getItem(key);
   }
}

export class SessionStorage implements IBrowserStorage {
   set(key: string, data: string): void {
      window.sessionStorage.setItem(key, data);
   }
   remove(key: string): void {
      window.sessionStorage.removeItem(key);
   }
   get(key: string): string | null | undefined {
      return window.sessionStorage.getItem(key);
   }
}

export class CookiesStorage implements IBrowserStorage {
   set(key: string, data: string): void {
      Cookies.set(key, data, {
         expires: 90,
         sameSite: 'strict',
         secure: true,
         path: '/'
      });
   }
   remove(key: string): void {
      Cookies.remove(key);
   }
   get(key: string): string | null | undefined {
      return Cookies.get(key);
   }
}

export class MultiStorage implements IBrowserStorage {
   private arr: Array<IBrowserStorage>;
   constructor(arr: Array<IBrowserStorage>) {
      this.arr = arr;
   }

   set(key: string, data: string): void {
      this.arr.forEach((el) => el.set(key, data));
   }
   remove(key: string): void {
      this.arr.forEach((el) => el.remove(key));
   }
   get(key: string): string | null | undefined {
      for (const el of this.arr) {
         const data = el.get(key);
         if (data) return data;
      }
      return undefined;
   }
   getAll(key: string): Array<string> {
      const result = new Array<string>();
      this.arr.forEach((el) => {
         const data = el.get(key);
         if (data && data.length > 0) result.push(data);
      });
      return result;
   }
}